import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "trigger"]
  static values = {
    userId: Number,
    context: { type: String, default: "nav" },
    delay: { type: Number, default: 500 }
  }

  connect() {
    this.showTimeout = null
    this.hideTimeout = null
    this.isLoaded = false
  }

  disconnect() {
    this.clearTimeouts()
  }

  mouseEnter() {
    this.clearTimeouts()
    this.showTimeout = setTimeout(() => {
      this.showCard()
    }, this.delayValue)
  }

  mouseLeave() {
    this.clearTimeouts()
    this.hideTimeout = setTimeout(() => {
      this.hideCard()
    }, 200) // Small delay to allow moving to the card
  }

  cardMouseEnter() {
    this.clearTimeouts()
  }

  cardMouseLeave() {
    this.hideCard()
  }

  showCard() {
    if (!this.isLoaded) {
      this.loadUserData()
    }
    this.cardTarget.classList.remove('hidden')
    this.positionCard()
  }

  hideCard() {
    this.cardTarget.classList.add('hidden')
  }

  clearTimeouts() {
    if (this.showTimeout) {
      clearTimeout(this.showTimeout)
      this.showTimeout = null
    }
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
  }

  async loadUserData() {
    try {
      console.log(`Loading hovercard for user ${this.userIdValue} with context ${this.contextValue}`)
      const response = await fetch(`/users/${this.userIdValue}/hovercard?context=${this.contextValue}`, {
        method: 'GET',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const turboStream = await response.text()
        console.log('Turbo stream received:', turboStream)
        Turbo.renderStreamMessage(turboStream)
        this.isLoaded = true
      } else {
        throw new Error(`Failed to load user data: ${response.status}`)
      }
    } catch (error) {
      console.error('Failed to load user data:', error)
      const content = document.getElementById(`user_hovercard_content_${this.userIdValue}_${this.contextValue}`)
      if (content) {
        content.innerHTML = '<p class="text-red-500 text-sm">Failed to load user data</p>'
      }
    }
  }  positionCard() {
    const trigger = this.triggerTarget
    const card = this.cardTarget
    const triggerRect = trigger.getBoundingClientRect()
    const cardRect = card.getBoundingClientRect()

    // Position card to the right of the trigger, or left if not enough space
    let left = triggerRect.right + 10
    if (left + cardRect.width > window.innerWidth) {
      left = triggerRect.left - cardRect.width - 10
    }

    // Position card vertically centered with the trigger
    let top = triggerRect.top + (triggerRect.height / 2) - (cardRect.height / 2)

    // Ensure card doesn't go off-screen
    if (top < 10) top = 10
    if (top + cardRect.height > window.innerHeight - 10) {
      top = window.innerHeight - cardRect.height - 10
    }

    card.style.left = `${left}px`
    card.style.top = `${top}px`
  }
}
